module.exports = __webpack_public_path__ + "assets/bar.png";